import { Reducer } from 'redux';
import { PointsListState, PointsListTypes } from './types';

const INITIAL_STATE: PointsListState = {
  pointsList: [],
  save: false,
};

const reducer: Reducer<PointsListState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LINE POINTS LIST
    case PointsListTypes.SET_POINTS_LIST:
      return {
        ...state,
        pointsList: action.payload.pointsList,
        save: action.payload.save,
      };

    default:
      return state;
  }
};

export default reducer;
